<template>
  <div>
    <loading v-if="isLoading" />
    <p v-else-if="!isLoading && !datacollection">No hay notas registradas.</p>
    <bar-chart
      v-else-if="!isLoading && datacollection"
      :chart-data="datacollection"
      :options="chartOptions"
      :styles="styles"
    ></bar-chart>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs"
import BarChart from "./BarChart.js"
import gql from "graphql-tag"
import Loading from "../../../shared/loading/loading.vue"

const DEFAULT_TOTAL_PERIODS = 10
const LOADING_MICRO_DELAY = 900

export default {
  components: {
    BarChart,
    Loading
  },
  props: ["styles", "studentId"],
  data() {
    return {
      isLoading: true,
      datacollection: null,
      maxGradeValue: 5.0
    }
  },
  apollo: {
    gradeChart: {
      query: gql`
        query GradeChart($studentId: ID!) {
          settings {
            maxGradeValue
            maxCareerTermDuration
          }
          terms(last: 30) {
            id
            name
          }
          studentGrades(studentId: $studentId) {
            termsGrades {
              term {
                id
              }
              grade {
                grade
              }
            }
          }
          studentProfile(studentId: $studentId) {
            student {
              id
              enrolledSince {
                id
                name
              }
            }
          }
        }
      `,
      variables() {
        return {
          studentId: this.studentId
        }
      },
      update(data) {
        setTimeout(() => {
          if (data.settings.maxGradeValue) {
            this.maxGradeValue = data.settings.maxGradeValue
          }
          if (data.studentGrades.termsGrades && data.studentGrades.termsGrades.length) {
            this.displayChart(data)
          }
          this.isLoading = false
        }, LOADING_MICRO_DELAY)
      }
    }
  },

  computed: {
    chartOptions() {
      return {
        type: "bar",
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          intersect: true,
          callbacks: {
            title: function(tooltipItem, data) {
              const termNames = data["termNames"]
              const idx = tooltipItem[0]["index"]
              return `${termNames[idx]}`
            },
            label: function(tooltipItem, data) {
              return `Semestre: ${tooltipItem["xLabel"]}`
            },
            afterBody: function(tooltipItem, data) {
              return `Promedio: ${tooltipItem[0]["yLabel"]}`
            }
          },
          backgroundColor: "#FFF",
          borderWidth: 1,
          borderColor: "#efefef",
          titleFontColor: "#0066ff",
          bodyFontColor: "#000",
          bodyFontSize: 11,
          displayColors: false
        },
        layout: {
          padding: {
            left: 50,
            right: 50,
            top: 0,
            bottom: 0
          }
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                min: 1,
                max: this.maxGradeValue,
                stepSize: Math.floor(this.maxGradeValue / 5)
              },
              gridLines: {
                display: true,
                drawBorder: false,
                color: "rgba(242, 242, 242, 1)"
              }
            }
          ]
        }
      }
    }
  },

  mounted() {},

  methods: {
    displayChart: function(data) {
      const terms = data.terms
      const grades = data.studentGrades.termsGrades
      const total_periods = data.settings.maxCareerTermDuration || DEFAULT_TOTAL_PERIODS
      const enrolled_since = data.studentProfile.student.enrolledSince || null
      let labels = []

      terms.forEach(function(term) {
        grades.forEach(function(grade) {
          if (term["id"] === grade["term"]["id"]) {
            term["grade"] = Math.trunc(grade["grade"]["grade"] * Math.pow(10, 1)) / Math.pow(10, 1)
          }
        })
      })

      let dataset_data = [],
        cutPoint = null,
        newArray = [],
        termNames = []

      if (enrolled_since && enrolled_since.hasOwnProperty("name")) {
        cutPoint = terms.findIndex(x => x.name === enrolled_since.name)
      } else {
        cutPoint = terms.findIndex(x => x.hasOwnProperty("grade"))
      }

      newArray = terms.slice(cutPoint)
      dataset_data = newArray.map(item => {
        termNames.push(item["name"])
        return item["grade"] || null
      })

      for (let count = 1; count <= total_periods; count++) {
        labels.push((count < 10 && "0") + count)
      }

      if (data.max_grade) {
        this.options["scales"]["yAxes"][0]["ticks"]["max"] = data.max_grade
      }

      const newData = {
        labels: labels,
        termNames: termNames,
        datasets: [
          {
            data: dataset_data,
            backgroundColor: "rgba(144, 202, 179, 0.4)",
            borderColor: "rgba(211, 234, 225, 1)",
            borderWidth: 0,
            lineTension: 0,
            pointRadius: 0,
            spanGaps: false
          }
        ]
      }
      this.$data.datacollection = newData
    }
  }
}
</script>

<style scoped>
p {
  font-size: 0.8em;
  text-align: center;
  margin-top: 5.5em;
}
</style>
